export async function sendContactEmail(formData) {
  const { name, email, phone, address, projectType, message } = formData;

  // EmailJS parameters
  const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

  if (!serviceId || !templateId || !publicKey) {
    console.error('EmailJS configuration is missing');
    throw new Error('Email service not configured');
  }

  const templateParams = {
    to_email: 'thiago@easyfloorkc.com',
    from_name: name,
    from_email: email,
    phone: phone,
    address: address || 'Not provided',
    project_type: projectType,
    message: message || 'No additional details provided',
  };

  try {
    const response = await fetch('https://api.emailjs.com/api/v1.0/email/send', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        service_id: serviceId,
        template_id: templateId,
        user_id: publicKey,
        template_params: templateParams,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to send email');
    }

    return await response.text();
  } catch (error) {
    console.error('EmailJS error:', error);
    throw error;
  }
} 